<template>
  <div style="padding: 20px 20px 20px 0">
    <div class="block">
      <span class="demonstration">年度：</span>
      <el-date-picker v-model="value3" type="year" placeholder="选择年"> </el-date-picker>
    </div>
    <!-- tab页 -->
    <el-tabs v-model="selectForm.type" @tab-click="getAll()">
      <el-tab-pane label="商业" name="商业">
        <!-- 表格 -->
        <!-- <table border="1" style="width: 80%">
          <tr>
            <td>月份</td>
            <td>一月</td>
            <td>二月</td>
            <td>三月</td>
            <td>四月</td>
            <td>五月</td>
            <td>六月</td>
            <td>七月</td>
            <td>八月</td>
            <td>九月</td>
            <td>十月</td>
            <td>十一月</td>
            <td>十二月</td>
          </tr>
          <tr>
            <td>应收</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>实收</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>完成率</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>考核等级</td>
            <td :colspan="12">
              <el-select v-model="selectValue" placeholder="请选择">
                <el-option value="优" label="优"></el-option>
                <el-option value="良" label="良"></el-option>
                <el-option value="中" label="中"></el-option>
                <el-option value="差" label="差"></el-option>
              </el-select>
            </td>
          </tr>
          <tr>
            <td>改进意见</td>
            <td :colspan="12">
              <textarea style="width: 100%" :rows="3" placeholder="请输入"></textarea>
            </td>
          </tr>
        </table> -->
      </el-tab-pane>
      <el-tab-pane label="物业" name="物业">
        <!-- 表格 -->
        <!-- <table border="1" style="width: 80%">
          <tr>
            <td>月份</td>
            <td>一月</td>
            <td>二月</td>
            <td>三月</td>
            <td>四月</td>
            <td>五月</td>
            <td>六月</td>
            <td>七月</td>
            <td>八月</td>
            <td>九月</td>
            <td>十月</td>
            <td>十一月</td>
            <td>十二月</td>
          </tr>
          <tr>
            <td>巡检</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>维修</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>投诉</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>考核等级</td>
            <td :colspan="12">
              <el-select v-model="selectValue" placeholder="请选择">
                <el-option value="优" label="优"></el-option>
                <el-option value="良" label="良"></el-option>
                <el-option value="中" label="中"></el-option>
                <el-option value="差" label="差"></el-option>
              </el-select>
            </td>
          </tr>
          <tr>
            <td>改进意见</td>
            <td :colspan="12">
              <textarea style="width: 100%" :rows="3" placeholder="请输入"></textarea>
            </td>
          </tr>
        </table> -->
      </el-tab-pane>
    </el-tabs>
    <el-table :data="data" v-loading="loading" border>
      <el-table-column align="center" prop="name" label="员工姓名"> </el-table-column>
      <el-table-column align="center" prop="number" label="员工号"> </el-table-column>
      <el-table-column align="center" prop="month" label="考核月度"> </el-table-column>
      <el-table-column align="center" prop="score" label="考核成绩"> </el-table-column>
      <el-table-column align="center" prop="text" label="考核建议"> </el-table-column>
      <el-table-column align="center" label="操作" width="230">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleView(scope.$index, scope.row)"
            >查看</el-button
          >
          <el-button
            size="mini"
            @click="handleEdit(scope.$index, scope.row)"
            type="primary"
            >修改</el-button
          >
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.$index, scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="formline.currentPage"
      @current-change="handleCurrentChange"
      style="margin: 20px 0"
      background
      layout="total,prev, pager, next"
      :total="totalNum"
    >
    </el-pagination>

    <el-dialog title="详情" :visible.sync="show" width="900px">
      <!-- 表格 -->
      <div>姓名：{{ form.name }}，工号{{ form.number }}</div>
      <table border="1" style="width: 100%; margin: 0 auto">
        <tr>
          <td>月份</td>
          <td>一月</td>
          <td>二月</td>
          <td>三月</td>
          <td>四月</td>
          <td>五月</td>
          <td>六月</td>
          <td>七月</td>
          <td>八月</td>
          <td>九月</td>
          <td>十月</td>
          <td>十一月</td>
          <td>十二月</td>
        </tr>
        <tr>
          <td>{{ selectForm.type == "商业" ? "应收" : "巡检" }}</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>{{ selectForm.type == "商业" ? "实收" : "维修" }}</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>{{ selectForm.type == "商业" ? "完成率" : "投诉" }}</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>考核等级</td>
          <td :colspan="12">
            <el-select v-model="form.score" placeholder="请选择" :disabled="onlyView">
              <el-option value="优" label="优"></el-option>
              <el-option value="良" label="良"></el-option>
              <el-option value="中" label="中"></el-option>
              <el-option value="差" label="差"></el-option>
            </el-select>
          </td>
        </tr>
        <tr>
          <td>改进意见</td>
          <td :colspan="12">
            <textarea
              :disabled="onlyView"
              v-model="form.text"
              style="width: 100%"
              :rows="3"
              placeholder="请输入"
            ></textarea>
          </td>
        </tr>
      </table>

      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="show = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="show = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { number } from "echarts/lib/export";
import { setTimeout } from "timers";

export default {
  data() {
    return {
      onlyView: false,
      formline: {
        currentPage: 1,
        pageSize: 10,
      },
      data: [],
      totalNum: 0,
      value3: "",
      selectValue: "",
      qx: [], //权限列表
      tabstype: "商业",
      form: {}, //表单
      oldForm: {}, //表单备份数据
      data: [], //表格数据
      selectForm: {
        //查询条件
        currentPage: 1,
        pageSize: 10,
        type: "商业", //类型（商业，物业）
      },
      show: false, //控制弹窗
      title: "",
      loading: false,
    };
  },
  methods: {
    getAll() {
      //获取表格数据
      let that = this;
      that.loading = true;
      console.log(this.selectForm.type);
      if (this.selectForm.type == "商业") {
        that.data = [
          {
            name: "张晓霞",
            number: " 1009732",
            month: "6月",
            score: "优",
            text: "继续保持",
          },
          {
            name: "齐盛",
            number: " 1009799",
            month: "6月",
            score: "优",
            text: "继续保持",
          },
          {
            name: "张一凡",
            number: " 1020799",
            month: "6月",
            score: "优",
            text: "继续保持",
          },
        ];
      } else {
        that.data = [
          {
            name: "李尔新",
            number: " 1011732",
            month: "6月",
            score: "优",
            text: "继续保持",
          },
          {
            name: "仓大海",
            number: " 100299",
            month: "6月",
            score: "优",
            text: "继续保持",
          },
          {
            name: "董其盛",
            number: " 103009",
            month: "6月",
            score: "优",
            text: "继续保持",
          },
        ];
      }
      setTimeout(() => {
        that.totalNum = that.data.length;
        that.loading = false;
      }, 1000);
      // this.$http
      //   .post(`/api/oneCardSolution/queryOneCardSolution`, this.selectForm)
      //   .then((res) => {
      //     console.log("this.data:", JSON.stringify(res.data));
      //     this.data = res.data.data.items;
      //     this.totalNum = res.data.data.totalNum;
      //   });
    },
    handleCurrentChange(num) {
      //当前页面变更
      this.formInline.currentPage = num;
      this.getAll();
    },
    handleView(index, row) {
      this.onlyView = true;
      this.form = row;
      this.show = true;
    },
    handleEdit(index, row) {
      this.onlyView = false;
      this.form = row;
      this.show = true;
    },
    handleDelete(index, row) {
      this.$confirm("确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error",
      })
        .then(() => {
          this.data.splice(index, 1);
          // this.$http.post("/api/bdContract/deleteContract", {
          // 	ids: userId
          // }).then(res => {
          // 	if (res.data.code == 0) {
          // 		this.$message.success(res.data.message)
          // 		this.getAll();
          // 	} else {
          // 		this.$message.error(res.data.message)
          // 	}
          // })
        })
        .catch(() => {
          this.$message({
            type: "warning",
            message: "已取消删除",
          });
        });
    },
  },
  created() {
    this.getAll();
  },
};
</script>

<style scoped="scoped"></style>
